var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureServiceV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7116 13.5117V17.0552C20.7116 17.5146 20.4666 17.939 20.0688 18.1687L17 19.9404",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9997 19.9404L3.93094 18.1687C3.53314 17.939 3.28809 17.5146 3.28809 17.0552V13.5117",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7113 4.94124L12.6426 3.16949C12.2448 2.93982 11.7546 2.93982 11.3568 3.16949L8.28809 4.94124",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7113 16.3687V19.9121C15.7113 20.3715 15.4662 20.7959 15.0684 21.0256L12.6426 22.4262C12.2448 22.6559 11.7546 22.6559 11.3568 22.4262L8.93094 21.0256C8.53314 20.7959 8.28809 20.3715 8.28809 19.9121V16.3687",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 14.9402L20.0684 13.1685C20.4662 12.9388 20.7113 12.5144 20.7113 12.055V9.25386C20.7113 8.79452 20.4662 8.37007 20.0684 8.1404L17.6426 6.73981C17.2448 6.51014 16.7546 6.51014 16.3568 6.73981L13.2881 8.51155",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7113 8.51155L7.64255 6.73981C7.24475 6.51014 6.75464 6.51014 6.35684 6.73981L3.93094 8.1404C3.53314 8.37007 3.28809 8.79452 3.28809 9.25386V12.055C3.28809 12.5144 3.53314 12.9388 3.93094 13.1685L6.9997 14.9402",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3558 9.59918C11.7536 9.36951 12.2437 9.36951 12.6415 9.59918L15.0674 10.9998C15.4652 11.2294 15.7103 11.6539 15.7103 12.1132V14.9144C15.7103 15.3738 15.4652 15.7982 15.0674 16.0279L12.6415 17.4285C12.2437 17.6581 11.7536 17.6581 11.3558 17.4285L8.92994 16.0279C8.53213 15.7982 8.28708 15.3738 8.28708 14.9144V12.1132C8.28708 11.6539 8.53213 11.2294 8.92994 10.9998L11.3558 9.59918Z",
    stroke: "#FF9A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureServiceV2);
export default __webpack_public_path__ + "static/media/FeatureServiceV2.f6cbecfa5ee6c0d08a38018243b6d7ba.svg";
export { ForwardRef as ReactComponent };